import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WizardStep } from 'app/dialogs/wizard/WizardStep';
import { async } from 'rxjs';

export enum EMailTrackingEvent {
  ALL = 'all',
  OPENED = 'opened',
  CLICKED = 'clicked',
  DELIVERED = 'delivered',
  COMPLAINED = 'complained',
}

@Component({
  selector: 'app-select-event-wizard-step',
  templateUrl: './select-event-wizard-step.component.html',
  styleUrls: ['./select-event-wizard-step.component.scss']
})
export class SelectEventWizardStepComponent implements OnInit, WizardStep {

  static NAME = 'select-event-wizard-step';

  wizardData: { [key: string]: any; };
  formGroup: FormGroup;
  currentEvent: EMailTrackingEvent;
  events = EMailTrackingEvent;

  constructor() { }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      event: new FormControl(this.wizardData[SelectEventWizardStepComponent.NAME].event || (this.currentEvent || EMailTrackingEvent.ALL), [Validators.required]),
    });
  }

  provideData() {
    return this.formGroup.value;
  }

  async validate() {
    return {
      success: this.formGroup.valid,
      errors: this.formGroup.valid ? undefined : ['You must select an event'],
    };
  }

}
